module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entity) ? _c('div', {
    staticClass: "component-client-action-buttons"
  }, [(_vm.item && _vm.canDo) ? _c('ul', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "dropdown menu",
    attrs: {
      "data-dropdown-menu": ""
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#Item-1"
    }
  }, [_vm._v("Action")]), _c('ul', {
    staticClass: "menu"
  }, [(_vm.canActivate) ? _c('li', [_c('a', {
    on: {
      "click": _vm.activate
    }
  }, [_vm._v("Activate")])]) : _vm._e(), (_vm.canSuspend) ? _c('li', [_c('a', {
    on: {
      "click": _vm.suspend
    }
  }, [_vm._v("Suspend")])]) : _vm._e(), (_vm.canDelete) ? _c('li', [_c('a', {
    on: {
      "click": _vm.deleteClient
    }
  }, [_vm._v("Delete")])]) : _vm._e(), (_vm.canEdit) ? _c('li', [_c('a', {
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")])]) : _vm._e(), (_vm.canDump) ? _c('li', [_c('a', {
    on: {
      "click": _vm.dump
    }
  }, [_vm._v("Dump Data")])]) : _vm._e(), _c('li', [_c('registration-token-reveal', {
    attrs: {
      "item": _vm.entity
    }
  })], 1)])])]) : (_vm.canDo) ? _c('div', {
    staticClass: "dropdown-buttons"
  }, [(_vm.canActivate) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.activate
    }
  }, [_vm._v("Activate")]) : _vm._e(), (_vm.canSuspend) ? _c('button', {
    staticClass: "button warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.suspend
    }
  }, [_vm._v("Suspend")]) : _vm._e(), (_vm.canDelete) ? _c('button', {
    staticClass: "button alert",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deletec
    }
  }, [_vm._v("Delete")]) : _vm._e()]) : _c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('p', [_vm._v("No actions available")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ca547998!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/ClientActionButtons.vue
// module id = 2694
// module chunks = 1